<!-- Author ミィン -->
<!-- 健康保険・被保管者の種別生年金保険　被保険者氏名変更（訂正）届 -->


<template>
  <div v-show="show">
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t('general.add')}}
        </el-button>
      </el-form-item>
    </el-form>

    <!-- Table -->
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('ins_name_change.employee_id')" align="center">
        <template slot-scope="scope">
          <!-- <div slot="reference" class="name-wrapper">
            <el-button type="text" @click="handleDetails(scope.$index, scope.row)">{{ scope.row.employee_id }}
            </el-button>
          </div> -->
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('ins_name_change.office_ref_num')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.office_ref_num }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('ins_name_change.ins_ref_num')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.ins_ref_num}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('ins_name_change.first_nm_mae')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.first_nm_mae + scope.row.last_nm_mae }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('ins_name_change.first_nm_go')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.first_nm_go + scope.row.last_nm_go }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t('general.edit')}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t('general.delete')}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t('general.print')}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview(scope.$index, scope.row)" plain>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- New -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="60%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-collapse accordion>
          <el-collapse-item :title="$t('general.general_info')" name="1" class="title" style="margin-left:10px">
            <el-row>
              <el-col :span="20">
                <div>
                  <el-form-item :label="$t('ins_name_change.employee_id')+':'" prop="employee_id"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id" style="margin-left:10px;margin-right:50px;width: 185px"
                      size="mini" :placeholder="$t('general.please_select')" @change="employeeIdSelected">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.office_ref_num')+':'" prop="office_ref_num"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.office_ref_num" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                    <el-button class="el-icon-info" type="text" @click="office_ref">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.ins_ref_num')+':'" prop="ins_ref_num"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_ref_num" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                    <el-button class="el-icon-info" type="text" @click="ins_ref">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.type')+':'" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.type" style="margin-left:10px;margin-right:0px;width: 185px"
                      size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in typeList" :key="item.typeId" :label="item.name" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-button class="el-icon-info" type="text" @click="open2">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.submit_date')+':'" prop="submit_date"
                    style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.submit_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('ins_name_change.title_name')" name="2" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('ins_name_change.first_nm_mae')+':'" prop="first_nm_mae"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.first_nm_mae" size="mini"
                      style="margin-left:10px;margin-right:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.first_nm_go')+':'" prop="first_nm_go"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.first_nm_go" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.first_nm_furi')+':'" prop="first_nm_furi"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.first_nm_furi" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('ins_name_change.last_nm_mae')+':'" prop="last_nm_mae"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.last_nm_mae" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.last_nm_go')+':'" prop="last_nm_go"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.last_nm_go" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.last_nm_furi')+':'" prop="last_nm_furi"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.last_nm_furi" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="60%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-collapse accordion>
          <el-collapse-item :title="$t('general.general_info')" name="1" class="title" style="margin-left:10px">
            <el-row>
              <el-col :span="20">
                <div>
                  <el-form-item :label="$t('ins_name_change.employee_id')+':'" prop="employee_id"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id" style="margin-left:10px;margin-right:50px;width: 185px"
                      size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.office_ref_num')+':'" prop="office_ref_num"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.office_ref_num" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                    <el-button class="el-icon-info" type="text" @click="office_ref">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.ins_ref_num')+':'" prop="ins_ref_num"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_ref_num" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                    <el-button class="el-icon-info" type="text" @click="ins_ref">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.type')+':'" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.type" style="margin-left:10px;margin-right:0px;width: 185px"
                      size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in typeList" :key="item.typeId" :label="item.name" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-button class="el-icon-info" type="text" @click="open2">{{$t('general.hint')}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.submit_date')+':'" prop="submit_date"
                    style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.submit_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('ins_name_change.title_name')" name="2" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('ins_name_change.first_nm_mae')+':'" prop="first_nm_mae"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.first_nm_mae" size="mini"
                      style="margin-left:10px;margin-right:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.first_nm_go')+':'" prop="first_nm_go"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.first_nm_go" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.first_nm_furi')+':'" prop="first_nm_furi"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.first_nm_furi" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('ins_name_change.last_nm_mae')+':'" prop="last_nm_mae"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.last_nm_mae" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.last_nm_go')+':'" prop="last_nm_go"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.last_nm_go" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.last_nm_furi')+':'" prop="last_nm_furi"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.last_nm_furi" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Detail -->
    <el-dialog :title="$t('general.detail')" :append-to-body="true" :visible.sync="dialogDetails" width="60%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-collapse accordion>
          <el-collapse-item :title="$t('general.general_info')" name="1" class="title">
            <el-row>
              <el-col :span="20">
                <div>
                  <el-form-item :label="$t('ins_name_change.employee_id')+':'" prop="office_ref_num">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.employee_id" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.office_ref_num')+':'" prop="office_ref_num">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.office_ref_num" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.ins_ref_num')+':'" prop="ins_ref_num">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.ins_ref_num" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <!-- <el-form-item label="被保険者証:" prop="health_ins_required">
                    <el-input
                      prefix-icon="el-icon-edit"
                      v-model="ruleForm.health_ins_required"
                      size="mini"
                      style="margin-left:10px;width: 185px"
                      readonly="readonly"
                    ></el-input>
                  </el-form-item>-->

                  <el-form-item :label="$t('ins_name_change.type')+':'" prop="type">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.type" size="mini"
                      style="margin-left:10px;width: 300px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.remark')+':'" prop="remark">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.remark" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.submit_date')+':'" prop="submit_date">
                    <el-date-picker v-model="ruleForm.submit_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" readonly="readonly">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('ins_name_change.title_name')" name="2">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('ins_name_change.first_nm_mae')+':'" prop="first_nm_mae">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.first_nm_mae" size="mini"
                      style="margin-left:10px;margin-right:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.first_nm_go')+':'" prop="first_nm_go">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.first_nm_go" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.first_nm_furi')+':'" prop="first_nm_furi">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.first_nm_furi" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('ins_name_change.last_nm_mae')+':'" prop="last_nm_mae">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.last_nm_mae" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.last_nm_go')+':'" prop="last_nm_go">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.last_nm_go" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('ins_name_change.last_nm_furi')+':'" prop="last_nm_furi">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.last_nm_furi" size="mini"
                      style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="cancel()" type="primary" size="medium">{{$t('general.cancel')}}
        </el-button>
      </span>
    </el-dialog>

    <br />

    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        health_ins_requiredList: [{
            health_ins_requiredId: 1,
            name: "要",
            value: "要"
          },
          {
            health_ins_requiredId: 2,
            name: "不要",
            value: "不要"
          }
        ],
        typeList: [{
            typeId: 1,
            name: "「1」坑内員以外の男子",
            value: "「1」坑内員以外の男子"
          },
          {
            typeId: 2,
            name: "「２」女子",
            value: "「２」女子"
          },
          {
            typeId: 3,
            name: "「３」抗内員",
            value: "「３」抗内員"
          },
          {
            typeId: 5,
            name: "「５」厚生年金基金加入員であって坑内員以外の男子",
            value: "「５」厚生年金基金加入員であって坑内員以外の男子"
          },
          {
            typeId: 6,
            name: "「６」厚生年金基金加入員である女子",
            value: "「６」厚生年金基金加入員である女子"
          },
          {
            typeId: 7,
            name: "「７」厚生年金基金加入員である坑内員",
            value: "「７」厚生年金基金加入員である坑内員"
          }
        ],
        ruleForm: {
          id: "",
          office_ref_num: "",
          ins_ref_num: "",
          first_nm_go: "",
          last_nm_go: "",
          first_nm_furi: "",
          last_nm_furi: "",
          health_ins_required: "",
          type: "",
          remark: "",
          submit_date: "",
          employee_id: "",
          first_nm_mae: "",
          last_nm_mae: ""
        },
        rules: {
          office_ref_num: [{
            required: true,
            message: this.$t("ins_name_change.enter_office_ref_num"),
            trigger: "blur"
          }],
          ins_ref_num: [{
            required: true,
            message: this.$t("ins_name_change.enter_ins_ref_num"),
            trigger: "blur"
          }],
          first_nm_go: [{
            required: true,
            message: this.$t("ins_name_change.enter_first_nm_go"),
            trigger: "blur"
          }],
          last_nm_go: [{
            required: true,
            message: this.$t("ins_name_change.enter_last_nm_go"),
            trigger: "blur"
          }]
        },
        tableData: [],
        empList: [{
          id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          post_code: "",
          birthday: "",
          birthday: "",
          gender: "",
          email: "",
          mynum: "",
          work_status: "",
          begin_date: "",
          end_date: "",
          cause: "",
          employee_type: "",
          title: "",
          work_content: "",
          address1: "",
          address2: "",
          address3: "",
          address_kn1: "",
          address_kn2: "",
          address_kn3: "",
          tel: "",
          bank_name: "",
          bank_branch: "",
          deposit_type: "",
          account: "",
          account_name: "",
          emp_insuranceID: "",
          emp_ins_begin_day: "",
          emp_ins_end_day: "",
          pensionID: "",
          health_insuranceID: "",
          basic_pensionID: "",
          salary_changeday: "",
          salary_month: "",
          commuting_fee: "",
          nation: "",
          resident: "",
          resident_code: ""
        }],
        empList1: [],
        emp: {
          id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          post_code: "",
          birthday: "",
          birthday: "",
          gender: "",
          email: "",
          mynum: "",
          work_status: "",
          begin_date: "",
          end_date: "",
          cause: "",
          employee_type: "",
          title: "",
          work_content: "",
          address1: "",
          address2: "",
          address3: "",
          address_kn1: "",
          address_kn2: "",
          address_kn3: "",
          tel: "",
          bank_name: "",
          bank_branch: "",
          deposit_type: "",
          account: "",
          account_name: "",
          emp_insuranceID: "",
          emp_ins_begin_day: "",
          emp_ins_end_day: "",
          pensionID: "",
          health_insuranceID: "",
          basic_pensionID: "",
          salary_changeday: "",
          salary_month: "",
          commuting_fee: "",
          nation: "",
          resident: "",
          resident_code: ""
        },
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        dialogDetails: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false
      };
    },
    methods: {
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/健康保険・厚生年金保険　被保険者氏名変更（訂正）届-" + "uid=" + uid + ".pdf");
      },

      employeeIdSelected() {
        // console.log(this.ruleForm.employee_id);
        let postData = this.qs.stringify({
          employee_id: this.ruleForm.employee_id
        });
        this.axios({
            method: "post",
            url: "/ListEmpList",
            data: postData
          })
          .then(response => {
            // console.log(response.data);
            this.empList1 = response.data;
            this.emp = this.empList1[0];
            let splitStr = this.emp.name.split(" ");
            this.ruleForm.first_nm_mae = splitStr[0];
            this.ruleForm.last_nm_mae = splitStr[1];
          })
          .catch(error => {
            console.log(error);
          });
      },
      open2() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("ins_name_change.gender_type"),
          message: h(
            "i", {
              style: "color: teal"
            },
            this.$t("ins_name_change.hint_open2")
          )
        });
      },
      office_ref() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("ins_name_change.office_ref_num"),
          message: h(
            "i", {
              style: "color: teal"
            },
            this.$t("ins_name_change.office_ref_hint")
          )
        });
      },
      ins_ref() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("ins_name_change.ins_ref_num"),
          message: h(
            "i", {
              style: "color: teal"
            },
            this.$t("ins_name_change.ins_ref_hint")
          )
        });
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id
        });
        this.axios({
            method: "post",
            url: "/InsNameChangePDF",
            data: postData
          })
          .then(response => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 700);
            // console.log(response);
          })
          .catch(error => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
            console.log(error);
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: "OK",
            cancelButtonText: this.$t("general.cancel"),
            type: "warning"
          })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id
            });
            this.axios({
                method: "post",
                url: "/deleteInsNameChange",
                data: postData
              })
              .then(response => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageInsNameChange")
                  .then(response => {
                    this.tableData = response.data;
                  })
                  .catch(error => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled")
            });
          });
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: this.$t("general.confirm"),
            cancelButtonText: this.$t("general.cancel"),
            type: "warning"
          })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => {});
      },
      handleCurrentChange() {
        // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
        let postData = this.qs.stringify({
          page: this.currentPage
        });
        this.axios({
            method: "post",
            url: "/pageInsNameChange",
            data: postData
          })
          .then(response => {
            this.tableData = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          office_ref_num: "",
          ins_ref_num: "",
          first_nm_go: "",
          last_nm_go: "",
          first_nm_furi: "",
          last_nm_furi: "",
          health_ins_required: "",
          type: "",
          remark: "",
          submit_date: "",
          employee_id: "",
          name: ""
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              office_ref_num: this.ruleForm.office_ref_num,
              ins_ref_num: this.ruleForm.ins_ref_num,
              first_nm_go: this.ruleForm.first_nm_go,
              last_nm_go: this.ruleForm.last_nm_go,
              first_nm_furi: this.ruleForm.first_nm_furi,
              last_nm_furi: this.ruleForm.last_nm_furi,
              health_ins_required: this.ruleForm.health_ins_required,
              type: this.ruleForm.type,
              remark: this.ruleForm.remark,
              submit_date: this.ruleForm.submit_date,
              employee_id: this.ruleForm.employee_id
            });
            this.axios({
                method: "post",
                url: "/insertInsNameChange",
                data: postData
              })
              .then(response => {
                this.axios
                  .post("/pageInsNameChange")
                  .then(response => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.cancel();
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed")
                    });
                  })
                  .catch(error => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed")
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              office_ref_num: this.ruleForm.office_ref_num,
              ins_ref_num: this.ruleForm.ins_ref_num,
              first_nm_go: this.ruleForm.first_nm_go,
              last_nm_go: this.ruleForm.last_nm_go,
              first_nm_furi: this.ruleForm.first_nm_furi,
              last_nm_furi: this.ruleForm.last_nm_furi,
              health_ins_required: this.ruleForm.health_ins_required,
              type: this.ruleForm.type,
              remark: this.ruleForm.remark,
              submit_date: this.ruleForm.submit_date,
              employee_id: this.ruleForm.employee_id
            });
            this.axios({
                method: "post",
                url: "/updateInsNameChange",
                data: postData
              })
              .then(response => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_failed")
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsInsNameChange")
          .then(response => {
            this.total = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
      getPages() {
        this.axios
          .post("/rowsInsNameChange")
          .then(response => {
            this.total = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      }
    },
    created() {
      this.axios
        .post("/pageInsNameChange")
        .then(response => {
          // console.log(response.data);
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });

      this.axios
        .post("/rowsInsNameChange")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });

      this.axios
        .post("/ListEmpListForInsNameChange")
        .then(response => {
          // console.log(response.data);
          this.empList = response.data;
          // console.log(this.empList);
        })
        .catch(error => {
          console.log(error);
        });
    }
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .item1 {
    visibility: hidden;
  }

  .item2 {
    visibility: hidden;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/HealthIns/InsNameChange.vue